<template>
  <b-container fluid>
    <b-row style="margin-bottom: 1rem;" align-h="between">
      <template
        v-if="
          object.fishname.options.length > 0 &&
            object.country.options.length > 0
        "
      >
        <b-col cols="10">
          <span>
            魚類名:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
              v-model="object.fishname.value"
              :options="object.fishname.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
          <span>
            縣市別:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 15vh; display: inline-grid; margin-right: 10px;"
              v-model="object.country.value"
              :options="object.country.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
        </b-col>
        <b-col v-if="object.table.ifshow" cols="auto">
          <b-button-group>
            <b-dropdown
              variant="outline-secondary"
              right
              v-b-tooltip.hover
              title="列表顯示項目"
              class="ml-1"
            >
              <template #button-content>
                <b-icon-table></b-icon-table>
              </template>
              <b-dropdown-form form-class="abc">
                <template v-for="field in object.table.fields">
                  <b-checkbox
                    style="min-width: max-content;"
                    v-if="field.toggleable !== false"
                    :key="field.key"
                    v-model="field.visible"
                    :value="true"
                    :unchecked-value="false"
                    inline
                  >
                    {{ field.label }}
                  </b-checkbox>
                </template>
                <!-- <b-form-checkbox v-for="(item, index) in fields" :key="index">{{item.label}}
                                  </b-form-checkbox> -->
              </b-dropdown-form>
            </b-dropdown>
          </b-button-group>
        </b-col>
      </template>
      <template v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </template>
    </b-row>
    <template v-if="object.table.ifshow">
      <b-row>
        <b-col>
          <b-table
            :items="object.table.items"
            :fields="visibleFields"
            :current-page="object.table.currentPage"
            :per-page="object.table.perPage"
            :busy="object.table.isBusy"
            responsive
            head-variant="green"
            striped
            hover
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="object.table.currentPage"
            :total-rows="object.table.totalRows"
            :per-page="object.table.perPage"
            small
          ></b-pagination>
        </b-col>
        <b-col cols="auto">
          <span>共 {{ object.table.totalRows }}筆資料</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          ※百分比(%)：該魚種的魚塭面積占該魚種全國魚塭總面積之百分比
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          資料來源:漁業署
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      object: {
        fishname: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        country: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        table: {
          ifshow: false,
          fields: [
            {
              key: "SIFS_TYPE",
              label: "魚種別",
              visible: true,
            },
            {
              key: "SIFS_CITY",
              label: "所屬縣市",
              visible: true,
            },
            {
              key: "SIFS_NUM",
              label: "無填寫-魚塭口數",
              visible: false,
            },
            {
              key: "SIFS_AREA",
              label: "無填寫-魚塭面積(公頃)",
              visible: false,
            },
            {
              key: "SIFS_NFPOOL",
              label: "無填寫-在池",
              visible: false,
            },
            {
              key: "SIFS_NFSTOCK",
              label: "無填寫-新放養",
              visible: false,
            },
            {
              key: "SIFS_FCNUM",
              label: "魚苗培育-魚塭口數",
              visible: false,
            },
            {
              key: "SIFS_FCHA",
              label: "魚苗培育-魚塭面積(公頃)",
              visible: false,
            },
            {
              key: "SIFS_FCI",
              label: "魚苗培育-在池",
              visible: false,
            },
            {
              key: "SIFS_FCSTOCK",
              label: "魚苗培育-新放養",
              visible: false,
            },
            {
              key: "SIFS_BFNUM",
              label: "種魚繁殖-魚塭口數",
              visible: false,
            },
            {
              key: "SIFS_BFHA",
              label: "種魚繁殖-魚塭面積(公頃)",
              visible: false,
            },
            {
              key: "SIFS_BFPOOL",
              label: "種魚繁殖-在池",
              visible: false,
            },
            {
              key: "SIFS_BFSTOCK",
              label: "種魚繁殖-新放養",
              visible: false,
            },
            {
              key: "SIFS_IFNUM",
              label: "中間養殖-魚塭口數",
              visible: false,
            },
            {
              key: "SIFS_IAHA",
              label: "中間養殖-魚塭面積(公頃)",
              visible: false,
            },
            {
              key: "SIFS_IMPOOL",
              label: "中間養成-在池",
              visible: false,
            },
            {
              key: "SIFS_ICSTOCK",
              label: "中間養成-新放養",
              visible: false,
            },
            {
              key: "SIFS_ANUM",
              label: "成魚養成-魚塭口數",
              visible: false,
            },
            {
              key: "SIFS_AHEC",
              label: "成魚養成-魚塭面積(公頃)",
              visible: false,
            },
            {
              key: "SIFS_APOOL",
              label: "成魚養成-在池",
              visible: false,
            },
            {
              key: "SIFS_ASTOCK",
              label: "成魚養成-新放養",
              visible: false,
            },
            {
              key: "SIFS_FWATER",
              label: "已完成調查魚塭口數-第一類(有水權)",
              visible: false,
            },
            {
              key: "SIFS_FNWATER",
              label: "已完成調查魚塭口數-第一類(無水權)",
              visible: false,
            },
            {
              key: "SIFS_SECOND",
              label: "已完成調查魚塭口數-第二類",
              visible: false,
            },
            {
              key: "SIFS_THIRD",
              label: "已完成調查魚塭口數-第三類",
              visible: false,
            },
            {
              key: "SIFS_SUBTOTAL",
              label: "已完成調查魚塭口數-小計",
              visible: false,
            },
            {
              key: "SIFS_HAWATER",
              label: "魚塭面積(公頃)-第一類(有水權)",
              visible: false,
            },
            {
              key: "SIFS_HANWATER",
              label: "魚塭面積(公頃)-第一類(無水權)",
              visible: false,
            },
            {
              key: "SIFS_HA2",
              label: "魚塭面積(公頃)-第二類",
              visible: false,
            },
            {
              key: "SIFS_HAIII",
              label: "魚塭面積(公頃)-第三類",
              visible: false,
            },
            {
              key: "SIFS_HASUBTOTAL",
              label: "魚塭面積(公頃)-小計",
              visible: true,
            },
            {
              key: "SIFS_PERCENT",
              label: "百分比(%)",
              visible: true,
            },
            {
              key: "SIFS_SAPOOL",
              label: "放養量-在池(尾、粒、隻)",
              visible: true,
            },
            {
              key: "SIFS_NSAPOOL",
              label: "新放養量-在池(尾、粒、隻)",
              visible: true,
            },
            {
              key: "SIFS_NFWATER",
              label: "養殖戶數-第一類(有水權)",
              visible: false,
            },
            {
              key: "SIFS_NFNWATER",
              label: "養殖戶數-第一類(無水權)",
              visible: false,
            },
            {
              key: "SIFS_NFSECOND",
              label: "養殖戶數-第二類",
              visible: false,
            },
            {
              key: "SIFS_NFTHIRD",
              label: "養殖戶數-第三類",
              visible: false,
            },
            {
              key: "SIFS_NFSUBTOTAL",
              label: "養殖戶數-小計",
              visible: true,
            },
            {
              key: "SIFS_FRY",
              label: "養殖戶類別統計-魚苗戶",
              visible: false,
            },
            {
              key: "SIFS_FCATEGORY",
              label: "養殖戶類別統計-養成戶",
              visible: false,
            },
          ],
          items: [],
          allitems: [],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          isBusy: true,
          pageoptions: [10, 50, 100],
        },
        window: {
          width: 0,
        },
      },
      apiGetFishStockSpecList: (data) =>
        this.userRequest.post("/API/Default/getFishStockSpecList", data),
      apiGetFishStockCityList: (data) =>
        this.userRequest.post("/API/Default/getFishStockCityList", data),
      apiGetFishStockStatisList: (data) =>
        this.userRequest.post("/API/Default/getFishStockStatisList", data),
    };
  },
  created() {
    // window.addEventListener("resize", this.handleResize);
    // this.handleResize();
    this.init();
  },
  destroyed() {
    // window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    visibleFields() {
      return this.object.table.fields.filter((field) => field.visible);
    },
    ifstacked() {
      return this.object.window.width <= 750;
    },
  },
  methods: {
    init() {
      this.FunctionToken(this.getFishStockSpecList, {});
      this.FunctionToken(this.getFishStockCityList, {});
    },
    getFishStockSpecList(data) {
      this.apiGetFishStockSpecList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.fishname.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.SIFS_TYPE,
                code: x.SIFS_TYPE,
                disabled: true,
              };
              this.object.fishname.options.push(obj);
            });
            this.object.fishname.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
          }
        })
        .catch((err) => console.warn(err));
    },
    getFishStockCityList(data) {
      this.apiGetFishStockCityList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.country.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.SIFS_CITY,
                code: x.SIFS_CITY,
                disabled: true,
              };
              this.object.country.options.push(obj);
            });
            this.object.country.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
          }
        })
        .catch((err) => console.warn(err));
    },
    getFishStockStatisList(data) {
      this.apiGetFishStockStatisList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.table.items = JSON.parse(json.Data);
            this.object.table.totalRows = this.object.table.items.length;
            this.object.table.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    getDataList() {
      if (
        this.object.fishname.value != null &&
        this.object.country.value != null
      ) {
        this.object.table.isBusy = true;
        this.object.table.ifshow = true;
        this.FunctionToken(this.getFishStockStatisList, {
          SIFS_TYPE: this.object.fishname.value.code,
          SIFS_CITY: this.object.country.value.code,
        });
      }
    },
    handleResize() {
      this.object.window.width = window.innerWidth;
    },
  },
  watch: {
    "object.fishname.value"() {
      this.getDataList();
    },
    "object.country.value"() {
      this.getDataList();
    },
  },
};
</script>
